<div class="main">
    <div class="text-center">
      <img src="assets/image/success-icon.svg" />
    </div>
    <div class="mt-3 text-center">
      <h2>Cadastro ativado!</h2>
      <p class="mt-3 mb-5">
        Sua conta foi ativada e já está pronta para ser acessada.
      </p>
    </div>
    <div>
      <button class="btn btn-block mt-3" type="button" (click)="goToLogin()">
        Fazer login
      </button>
    </div>
  </div>
  